/** connections group: connection requests and contact reveal (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const connectionsPermissions = [
  'connection:read',
  'connection:initiate',
  'connection:respond',
  'contact:reveal',
] as const;

export type ConnectionsPermission = (typeof connectionsPermissions)[number];
